import { initialState } from './_defaults';

export default () => initialState;
